import React from 'react';
import styled from 'styled-components';

import {
  Section,
  Container,
  Grid,
  Col,
  AnchorText,
  Button,
} from '../../common';

const StyledSection = styled((props) => <Section {...props} />)`
  background-color: ${(props) => props.$bgColor};
  & span {
    color: ${(props) => props.$spanColor};
  }
`;

const StyledTagline = styled.span`
  color: ${(props) => props.$spanColor};
`;

const PageMissingDefault = (props) => {
  const { sanity, page } = props;
  const { business, colors, navbars } = sanity;
  const { gbp } = page;

  return (
    <StyledSection
      padding="custom"
      bgColor={colors?.neutral?.white}
      h2Color={colors?.neutral?.darker}
      h3Color={colors?.primary?.dark}
      $spanColor={colors?.accent?.light}
      classes="pt-[10rem] lg:pt-[15rem] pb-24"
    >
      <Container
        initialOpacity={1}
        initialScale={1}
        classes="max-w-md px-4 text-center sm:max-w-3xl lg:max-w-7xl"
      >
        <StyledTagline
          $spanColor={colors?.accent?.dark}
          className="text-base font-semibold uppercase tracking-wider"
        >
          {business?.name}
        </StyledTagline>
        <h1 className="mx-auto mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl lg:max-w-3xl">
          Page Does Not Exist!
        </h1>
        <Container initialOpacity={1} initialScale={1} type="sm">
          <div className="mx-auto mt-12 space-y-2 text-center text-lg lg:max-w-3xl lg:text-xl">
            <p className="px-12 font-bold lg:px-0">
              Looks like you've hit a 404 error. The URL entered does not
              exist...
            </p>
            <p>Need to get a hold of us? Try this link instead:</p>
            <div className="mx-auto pt-6">
              <Button
                linkType="internal"
                internalLink={navbars?.primaryNavCtaButtonLink?.slug?.current}
                label="Contact Us"
                sanity={sanity}
              />
            </div>
          </div>
        </Container>
      </Container>
    </StyledSection>
  );
};

export { PageMissingDefault };
